<template>
    <label class="numbers-item" :class="classes">
        <template v-if="!canBuyMore && !item.selected">
        <input
            type="checkbox"
            name="number"
            hidden
            data-element="number-checkbox"
            :value="item.id"
            :checked="item.selected"
        />
        </template>
        <template v-else>
        <input
            type="checkbox"
            name="number"
            hidden
            data-element="number-checkbox"
            :value="item.id"
            :checked="item.selected"
            @change.prevent="toggle()"
            v-if="canBuy"
        />
        </template>
        <div v-html="item.htmlFormatted(patterns)" />
    </label>
</template>

<script>
import ModelNumber from '../models/number';

export default {
    name: "NumberItem",
    props: {
        item: {
            type: ModelNumber
        },
        canBuy: {
            type: Boolean,
            default: true
        },
        canBuyMore: {
            type: Boolean,
            default: true
        },
        patterns: {
            type: Array
        }
    },
    computed: {
        classes () {
            let classes = [];
            if (this.canBuy && (this.canBuyMore || this.item.selected)) {
                if (this.item.selected) {
                    classes.push('active')
                }
            } else if (!this.canBuyMore) {
                classes.push('opacity-block')
            } else {
                classes.push('disabled')
            }
            if (this.item.error) {
                classes.push('error')
            }
            return classes
        }
    },
    methods: {
        toggle () {
            if (this.item.selected) {
                this.$emit('removeNumber', this.item)
            } else {
                this.$emit('addNumber', this.item)
            }
        }
    }
}
</script>

<style lang="scss">

    .opacity-block {
        opacity: 0.5;
        cursor: default;
    }
</style>